import type { WorkItemSummary, WorkItemDeliveryStatus } from '../api'

export function buildSummary(status: WorkItemDeliveryStatus): string {
    const builds = status.builds
    if (!builds.length) { return status.mergeState === 'no-pr' ? 'Not started' : 'No build for current commit' }
    if (builds.some(b => b.result === 'failed')) { return 'Failed' }
    if (builds.some(b => b.state === 'inProgress' || b.state === 'cancelling')) { return 'Running' }
    if (builds.some(b => b.state === 'notStarted' || b.state === 'postponed')) { return 'Queued' }
    if (builds.some(b => b.result === 'canceled')) { return 'Canceled' }
    if (builds.some(b => b.result === 'partiallySucceeded')) { return 'Partially succeeded' }
    return builds.every(b => b.state === 'completed' && b.result === 'succeeded') ? 'Succeeded' : 'Unknown'
}

export function groupBoardItems(items: WorkItemSummary[]): { epicId: number | null; title: string; items: WorkItemSummary[] }[] {
    const groups = new Map<number | null, { epicId: number | null; title: string; items: WorkItemSummary[] }>()
    for (const item of items) {
        const key = item.epicId
        let group = groups.get(key)
        if (!group) {
            group = { epicId: key, title: item.epicTitle ?? (key ? `Epic #${key}` : 'Ungrouped items'), items: [] }
            groups.set(key, group)
        }
        group.items.push(item)
    }
    return [...groups.values()]
}

